import React from "react";

const CarrotUp = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.73 17.885L22.5 16.115L12.5 6.11499L2.5 16.115L4.27 17.885L12.5 9.65499L20.73 17.885Z"
        fill="#102337"
      />
    </svg>
  );
};

export default CarrotUp;
